import React, { createContext, useContext, useState } from "react";

const PaginationContext = createContext(null);

export const GlobalProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const value = {
    page,
    setPage,
    limit,
    setLimit,
    total,
    setTotal,
  };

  return (
    <PaginationContext.Provider value={value}>
      {children}
    </PaginationContext.Provider>
  );
};

export const usePagination = () => {
  const context = useContext(PaginationContext);
  if (!context) {
    throw new Error("usePagination must be used inside GlobalProvider");
  }
  return context;
};
